import { Link } from "react-router-dom";

const ButtonMailto = ({ mailto, label, className}) => {
    return (
        <Link
            to='#'
            onClick={(e) => {
                window.location.href = mailto;
                e.preventDefault();
            }} 
            className={className} style={{paddingRight: "2%", textDecoration: "none"}}
        >
            {label}
        </Link>
    );
};

export default ButtonMailto;